import MinersTableTabs from "@components/global/MinersTableTabs";
import MinersTableSubTabs from "@components/global/MinersTableTabs/MinersTableSubTabs";
import Checkbox from "@components/global/new/Checkbox/Checkbox";
import type { IAdminMinerTable } from "@services/getMinerInfo";
import { useIntl } from "react-intl";
import styles from "../Machines.module.scss";
import MinerContextProvider from "../MinerRow/MinerContext";
import MinerPhoneSizeRow from "../MinerRow/MinerPhoneSizeRow";
import SkeletonMiner from "../MinerRow/SkeletonMiner/SkeletonMiner";
import { UnknownMinerPhoneSizeRow } from "../MinerRow/UnknownMinerRow";
import minerTableHeaders, {
  MinersTableHeaderId,
} from "./Header/minerTableHeaders";
import type { useMinersTableControl } from "./useMinersTableControl";

type MinersTableControl = ReturnType<typeof useMinersTableControl>;

interface MinersTableMobileViewProps {
  readonly control: MinersTableControl;
  readonly isSm: boolean;
}

function MinersTableMobileView({ control, isSm }: MinersTableMobileViewProps) {
  const { formatMessage } = useIntl();

  return (
    <>
      <div className={styles.mobileCheckboxAll}>
        {isSm && <MinersTableTabs className={styles.miners_tabs} />}
        {isSm && control.subtab !== undefined && (
          <MinersTableSubTabs className={styles.miners_tabs} />
        )}
        {control.tab !== "unknown" && (
          <Checkbox
            pulse={control.pulseAllCheckbox}
            text={formatMessage({ id: "machines.table.all" })}
            onClick={control.selectAll}
            checked={control.selectedAll}
          />
        )}
      </div>
      <div className={styles.table_content}>
        {control.tab === "unknown" ? (
          control.loading ? (
            <SkeletonMiner />
          ) : (
            control.unknownMiners.map((miner, i) => (
              <UnknownMinerPhoneSizeRow key={miner.id} miner={miner} pos={i} />
            ))
          )
        ) : control.loading ? (
          <SkeletonMiner />
        ) : !control.miners?.length ? (
          <div className={styles.empty_minerList}>
            {formatMessage({ id: "machines.table.empty" })}
          </div>
        ) : (
          control.miners.map((miner, i) => {
            if (!miner) return <></>;
            return (
              <MinerContextProvider miner={miner} key={miner.id}>
                <MinerPhoneSizeRow
                  selectMiner={(m: IAdminMinerTable) =>
                    control.selectMinerByID(m.id)
                  }
                  header={minerTableHeaders.filter(
                    (item) =>
                      control.isAdmin || item.id !== MinersTableHeaderId.CUSTOMER
                  )}
                  makeSelectedMiner={control.makeSelectedMiner}
                  key={miner.id}
                  pos={i}
                />
              </MinerContextProvider>
            );
          })
        )}
      </div>
    </>
  );
}

export default MinersTableMobileView;
